const flex = "atoms-module_flex_3DCW-0eq";
const block = "atoms-module_block_md4gSrcu";
const hidden = "atoms-module_hidden_oVqyi1RA";
const alignCenter = "atoms-module_alignCenter_4pCpghSp";
const gap4 = "atoms-module_gap4_-ZE-xH-X";
const gap8 = "atoms-module_gap8_S9UNRtTd";
const gap16 = "atoms-module_gap16_xzBC38Ou";
const relative = "atoms-module_relative_akoQRNue";
const desktopOnly = "atoms-module_desktopOnly_-q1pODQd";
const mobileOnly = "atoms-module_mobileOnly_cgycZy-J";
const atoms = {
  flex,
  block,
  hidden,
  alignCenter,
  gap4,
  gap8,
  gap16,
  relative,
  desktopOnly,
  mobileOnly
};
export {
  alignCenter,
  block,
  atoms as default,
  desktopOnly,
  flex,
  gap16,
  gap4,
  gap8,
  hidden,
  mobileOnly,
  relative
};
